import { PRINTING_TYPES } from "/cdn/shop/t/98/assets/printingOptions.constant.js?cash48";
import { GARMENT_OPTIONS } from "/cdn/shop/t/98/assets/garmentOptions.constant.js";
import { ReviewObject } from "/cdn/shop/t/98/assets/reviewObject.js?cash48";
import formSectionHeader from "/cdn/shop/t/98/assets/formSectionHeader.js";
import reviewField from "/cdn/shop/t/98/assets/reviewField.js?cash48";
import fileInput from "/cdn/shop/t/98/assets/fileInput.js?cash48";

export default {
    props: [
        "quote",
        "onlyShow",
        "fileErrors"
    ],
    components: {
        formSectionHeader,
        reviewField,
        fileInput,
    },
    data() {
        return {
            garmentOptions: GARMENT_OPTIONS,
            printingTypes: PRINTING_TYPES,
            reviewObject: new ReviewObject(this.$props.quote),
        }
    },
    methods: {
        transformLocationList(locations) {
            if (!locations?.length) return "";

            return locations.map((location) => {
                return location.replaceAll("_", " ");
            }).join(", ");
        },
        getGarmentOptionName(type, option) {
            return this.garmentOptions[type].find(item => item.value === option).label;
        },
        isImage(fileName) {
            return /\.(png|svg)$/i.test(fileName);
        },
        downloadFile(file) {
            let a = document.createElement("a");
            a.download = file?.name;
            a.href = file?.path;
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            a.remove();
        },
    },
    watch: {
        quote: {
            handler: function (newVal) {
                this.reviewObject = new ReviewObject(newVal);
            },
            deep: true,
        }
    },
    template: `
        <div class="review-section-wrapper">
            <form-section-header v-if="!onlyShow" title="Review"></form-section-header>

            <div class="review-section-header contact-section-header">
                <div class="review-section-header-title">Contact Information</div>

                <span v-if="!onlyShow" @click="$emit('changeCurrentStep', { type: 'contact_information', stepNumber: 0 })"
                    class="review-section-edit-btn">Edit
                </span>
            </div>

            <div class="review-section-container">
                <div class="review-section-contact-fields">
                    <review-field title="First Name" :value="reviewObject?.first_name">
                    </review-field>
                    <review-field title="Last Name" :value="reviewObject?.last_name">
                    </review-field>
                    <review-field title="Email" :value="reviewObject?.email"></review-field>
                    <review-field title="Phone Number" :value="reviewObject?.phone_number">
                    </review-field>
                    <review-field title="Company" :value="reviewObject?.company"></review-field>
                </div>
            </div>

            <template v-for="type in reviewObject?.printing_types">
                <div class="review-section-header">
                    <div class="review-section-header-title">{{ printingTypes[type] }}</div>

                    <span v-if="!onlyShow" @click="$emit('changeCurrentStep', { type: type, stepNumber: 2 })"
                        class="review-section-edit-btn">Edit
                    </span>
                </div>

                <div class="review-section-container">
                    <div v-if="type === 'other'">
                        <div class="full-width">
                            <review-field title="Request Details" :is-full-width="true" :value="reviewObject?.[type]?.request_details" :is-capitalize-value="true">
                            </review-field>
                        </div>
                    </div>

                    <div v-if="type === 'dye_sublimation' || type === 'embroidery' || type === 'direct_to_garment'" class="review-section-subtitle-wrapper">
                        <div v-for="option in reviewObject?.[type]?.garment_options"
                            class="review-section-subtitle-container">
                            <div class="review-section-option-title full-width">{{getGarmentOptionName(type, option?.garment) + ':' }}</div>

                            <review-field title="Quantity" :is-inline="true" :is-full-width="true" :value="option?.count">
                            </review-field>

                            <review-field title="Printing Locations" :is-capitalize-value="true" :is-full-width="true"
                                :value="transformLocationList(option?.printing_locations)">
                            </review-field>
                        </div>
                    </div>

                    <div v-if="fileErrors?.[type] && !onlyShow" class="custom-file-input-error">
                        Please upload a file
                    </div>

                </div>

                <div class="review-section-file-wrapper">
                    <file-input v-if="!onlyShow" :uploaded-files="reviewObject?.[type]?.files" :name="type"
                        @upload="$emit('uploadFiles', $event, type)" @delete="$emit('deleteFile', $event, type)">
                    </file-input>


                    <div v-if="onlyShow" class="review-section-file-show-wrapper">
                        <div v-for="(file, index) in reviewObject?.[type]?.files" :key="index" class="review-section-file-show-container">
                            <img v-if="isImage(file.path)" :src="file.path" class="review-section-file-show-image" />
                            <span v-else @click="downloadFile(file)"
                                class="review-section-edit-btn"
                                v-html="file.name"></span>
                        </div>
                    </div>
                </div>

                <div v-if="onlyShow && reviewObject?.[type]?.price" class="review-section-total" v-html="'Total: $' + reviewObject?.[type]?.price"></div>
            </template>
        </div>
`,
};